module.exports = __webpack_public_path__ + "img/md-paw.3fc1ee09.svg";